import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-update-expiration-date-dialog',
  templateUrl: './update-expiration-date-dialog.component.html',
  styleUrls: ['./update-expiration-date-dialog.component.scss']
})
export class UpdateExpirationDateDialogComponent implements OnInit {
  minDate: Date;
  expirationDate: Date;
  maxDate: Date;

  constructor(
    public dialogRef: MatDialogRef<UpdateExpirationDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Expecting data to include `approvedDate`
  ) { }

  ngOnInit() {
    const currentDate = new Date(); // Current date
    this.minDate = currentDate; // Set minDate to current date
  
    if (this.data.approvedDate) {
      // If approvedDate is provided, compute maxDate based on it (+90 days)
      this.maxDate = this.getMaxDate(this.data.approvedDate);
      this.expirationDate = this.maxDate; // Default selection
    } else if (this.data.computedExpirationDate) {
      // Fallback if approvedDate is not provided but computedExpirationDate is
      const computedDate = new Date(this.data.computedExpirationDate);
      this.maxDate = computedDate;
      this.expirationDate = computedDate;
    } else {
      this.maxDate = currentDate;
      this.expirationDate = currentDate;
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getMaxDate(approvedDate: Date): Date {
    const approvedDateObj = new Date(approvedDate);
    approvedDateObj.setDate(approvedDateObj.getDate() + 90);
    return approvedDateObj;
  }
}
